/**
*功能名称：布局组件
*创 建 人：弋强
*日    期：2022/05/05 15:56:49
*/
import { BaseVue } from "@newview/base-web";
import { Component, Prop, Watch } from "vue-property-decorator";
import { grid, comForm, customModal } from "@newview/ui";
@Component({
    components: {

    }
})
export default class Layout extends BaseVue {

    //#region 接口定义区

    //#endregion 接口定义区

    //#region 变量定义区

    //#endregion 变量定义区

    //#region 事件定义区

    mounted() {
        //页面渲染完出发事件
    }

    //#endregion 事件定义区

    //#region 方法定义区

    //#endregion 方法定义区
}